export const formatCurrency = (cents:any, noSymbol = false) => {
    return Intl.NumberFormat('en-US').format(cents);
  };